class Element {
  constructor() {
    this.listeners = {};
  }

  mount(el) {
    if (typeof el === 'string') {
      el = document.querySelector(el)[0];
    }

    el.innerHTML = `
      <div id='stripe-elements'>
        <p>Click to simulate filling in Stripe Elements</p>
      </div>
    `;

    const changed = () => {
      (this.listeners['change'] || []).forEach((handler) =>
        handler({ complete: true })
      );
    };

    const fakeElement = document.querySelector('#stripe-elements');
    if (fakeElement) {
      fakeElement.addEventListener('click', changed, false);
    }
  }

  on(event, handler) {
    this.listeners[event] = this.listeners[event] || [];
    this.listeners[event].push(handler);
  }

  off(event, handler) {
    this.listeners[event] = this.listeners[event] || [];
    this.listeners[event] = this.listeners[event].filter(
      (previouslyAddedFn) => previouslyAddedFn !== handler
    );
  }

  update() {}

  destroy() {}
}

const fakeStripe = () => ({
  elements: () => ({
    create: () => new Element(),
    getElement: () => {},
  }),

  confirmCardSetup: () =>
    new Promise((resolve) => {
      if (window.StripeTestData.returnCardSetupError) {
        resolve({
          error: {
            code: 'card_declined',
            message: 'Your card was declined.',
          },
        });
      } else {
        resolve({});
      }
    }),

  confirmCardPayment: () =>
    new Promise((resolve) => {
      resolve({});
    }),

  createPaymentMethod: (params) =>
    $.ajax({
      url: '/api/v1/stripe/fake/v1/payment_methods',
      method: 'POST',
      data: {
        ...{},
        ...params,
        country: params['billing_details']['address']['country'],
      },
    }),

  paymentRequest: (config) => {
    window.stripePaymentRequestLabelForSystemSpecs = config.total.label;

    const stripeAccountCountryCodes = ['US', 'GB'];

    if (!stripeAccountCountryCodes.includes(config.country)) {
      throw new IntegrationError();
    }

    return {
      canMakePayment: () =>
        new Promise((resolve) => {
          resolve({ applePay: window.enableApplePay });
        }),
      on: (event, handler) => {
        document
          .querySelector('.express-donate-button')
          .addEventListener(event, handler);
      },
      show: () => {
        $.ajax({
          url: '/api/v1/stripe/fake/v1/payment_methods',
          method: 'POST',
          data: {
            country: config.country,
          },
          success: (response) => {
            const event = new CustomEvent('paymentmethod');

            event.complete = () => {
              class InvalidAccessError extends Error {
                constructor(...params) {
                  super(...params);
                  this.name = 'InvalidAccessError';
                }
              }

              if (window.StripeTestData.raiseInvalidAccessError) {
                throw new InvalidAccessError();
              }
            };
            event.paymentMethod = { id: response.paymentMethod.id };
            if (window.StripeTestData.billing_details) {
              event.paymentMethod.billing_details =
                window.StripeTestData.billing_details;
            }
            event.payerName = window.StripeTestData.payerName;
            event.payerEmail = window.StripeTestData.payerEmail;

            setTimeout(
              () =>
                document
                  .querySelector('.express-donate-button')
                  .dispatchEvent(event),
              1000
            );
          },
        });
      },
    };
  },

  createToken: () =>
    new Promise((resolve) => {
      resolve({ token: { id: 'cvctok_123' } });
    }),
});

export default fakeStripe;
